import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Layout, Row, Col } from 'antd';

import Header from './Header/Header';
import GlobalFooter from './GlobalFooter';

const { Content } = Layout;

const MainLayout = props => {
  const { children } = props;
  const [visible, setVisible] = useState(false);

  return (
    <Layout className="app-layout bg-color-dark-90">
      <Header visible={visible} setVisible={setVisible} />

      <Content className="content-main">
        <Row justify="center">
          <Col xxl={20} xl={22} span={24}>
            {children}
          </Col>
        </Row>
      </Content>

      <GlobalFooter />
    </Layout>
  );
};

MainLayout.propTypes = {
  children: PropTypes.object
};

export default MainLayout;
